import React from 'react';

export default function ProcessListBenefitsIntake() {
  return (
    <va-process-list>
      <va-process-list-item header="Check your eligibility">
        <p>
          To receive reimbursement for licensing and certification test fees,
          you must apply separately and be found eligible for the VA education
          benefits that you want to use.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Gather your information">
        <h4>Here’s what you’ll need to fill out this form:</h4>
        <ul>
          <li>
            Your social security number or VA file number along with payee
            number (if applicable)
          </li>
          <li>Your current mailing address and contact information</li>
          <li>
            The name of the licensing or certification test and date test was
            taken
          </li>
          <li>
            The name and address of organization issuing the license or
            certification
          </li>
          <li>A receipt showing that you have paid in full</li>
          <li>
            A copy of your test results. If you do not have your test results
            but have a copy of your license or certification that clearly
            displays your name, you can attach that.
          </li>
        </ul>
      </va-process-list-item>
      <va-process-list-item header="Fill out the online form">
        <p>
          We’ll take you through each step of the process. It should take about
          15 minutes. You’ll also be provided the opportunity to give additional
          commentary regarding your licensing or certification test.
        </p>
        <p>
          <strong>Note:</strong> When you fill out your form, you will be asked
          for your address. When you update your address, your VA Profile
          address will also update.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Submit the online form">
        <p>
          Your completed form will submit automatically once you are done
          filling out information about your prep course and uploading your
          supporting documents.
        </p>
      </va-process-list-item>
    </va-process-list>
  );
}
